<template>
  <div v-if="open"
       class="cookies-banner"
       :class="{ landing: landing }">
    <p>{{ $t('cookies.enWegowUtilizamosCookiesParaMejorarTuExperiencia') }}</p>
    <p>
      {{ $t('cookies.siContinuasNavegandoAceptasSuUso') }}
      <span to="/cookies_settings">{{ $t('cookies.politicaDeCookies') }}</span>
    </p>
    <span class="close-arrow" />
  </div>
</template>

<script>
export default {
  props: {
    landing: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    open: false
  }),
  mounted() {
    var cookiesSettings =
      this.$cookies.get('wegow.cookies_settings') ||
      this.$cookies.get('cookies_settings')
    if (!cookiesSettings) {
      this.open = true
      window.addEventListener('scroll', this.closeBanner)
      window.addEventListener('click', this.closeBanner)
      window.onclick = this.closeBanner
      this._setCookie(0)
    } else {
      this.$store.dispatch('cookies/acceptCookie')
    }
  },
  methods: {
    closeBanner: function() {
      this.open = false
      this._setCookie(1)
      window.removeEventListener('scroll', this.closeBanner)
      window.removeEventListener('click', this.closeBanner)
    },
    _setCookie(option) {
      if (option) this.$store.dispatch('cookies/acceptCookie')
      this.$cookies.set('wegow.cookies_settings', option)
      this.$cookies.set('cookies_settings', option)
    }
  }
}
</script>

<style lang="scss">
@import './cookies.sass';
</style>
